export enum USER_TYPE {
	SUPER_ADMIN = "super-admin",
	ORGANISATION_ADMIN = "organisation_admin",
	ORGANISATION_CONSULTANT_MANAGER = "organisation_consultant_manager",
	CUSTOMER_USER = "customer_user",
	CONSULTANT = "consultant",
}
